export const ReportTypeLabel = {
  MASTER_LISTING: 'Master Listing',
  INTEREST_CHARGE: 'Interest Charges',
  MISC_BILLING: 'Misc Billing',
  LOAN_MATURITY: 'Loan Maturity',
  OVERDUE: 'Overdue',
  COLLECTION: 'Collection',
  CUSTOMER_LOAN: 'Loan (C-NC)',
  CUSTOMER_LOAN_INTEREST: 'Interest (C-NC)',
  LATE_CHARGES: 'Late Charges',
  PARTNER_INCENTIVE: 'Partner Incentive',
  KPKT: 'KPKT',
  AGING_REPORT: 'Aging',
  CUSTOMER_DETAILS: 'Extra Payment',
  STAMP_DUTY: 'Stamp Duty',
  LOAN_INSURANCE: 'Loan Insurance',
  SME_MONTHLY_DEDUCTION: 'SME Monthly Deduction',
  WAIVER_REPORT: 'Waiver',
  EARLY_SETTLED: 'Early Settled',
};
